import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../ThemeContext';
import { useState, useEffect } from 'react';

const NAV_LINKS = [
  ['/', 'Home'],
  ['/predict', 'Predict'],
  ['/about', 'About'],
  ['/industries', 'Industries'],
  ['/research', 'Research'],
  ['/benchmark', 'Benchmark'],
  ['/architecture', 'Architecture'],
  ['/contact', 'Contact'],
];

export default function Navbar() {
  const loc = useLocation();
  const { dark, toggle } = useTheme();
  const [views, setViews] = useState(0);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    try {
      const d = JSON.parse(localStorage.getItem('fiveg_views') || '{"t":0}');
      setViews(d.t || 0);
    } catch (e) {}
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [loc.pathname]);

  const accent   = dark ? '#00d4ff' : '#0078c8';
  const bg       = dark
    ? (scrolled ? 'rgba(3,8,18,0.98)' : 'rgba(3,8,18,0.92)')
    : (scrolled ? 'rgba(245,250,255,0.98)' : 'rgba(245,250,255,0.92)');
  const borderC  = dark ? 'rgba(0,212,255,0.14)' : 'rgba(0,100,200,0.15)';
  const logoC    = dark ? '#e8f4ff' : '#0a1e3d';
  const idleC    = dark ? 'rgba(180,215,245,0.65)' : 'rgba(10,30,60,0.58)';
  const activeC  = accent;
  const activeBg = dark ? 'rgba(0,212,255,0.1)' : 'rgba(0,120,200,0.1)';
  const activeBd = dark ? 'rgba(0,212,255,0.4)' : 'rgba(0,120,200,0.4)';
  const shadow   = scrolled
    ? (dark ? '0 2px 24px rgba(0,0,0,0.55)' : '0 2px 24px rgba(0,100,200,0.1)')
    : 'none';
  const mobileBg = dark ? 'rgba(3,8,18,0.99)' : 'rgba(245,250,255,0.99)';

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700;900&family=Inter:wght@400;500;600&display=swap');
        .nav {
          position:fixed;top:0;left:0;right:0;z-index:1000;
          height:60px;display:flex;align-items:center;padding:0 24px;
          justify-content:space-between;
          background:${bg};backdrop-filter:blur(22px);-webkit-backdrop-filter:blur(22px);
          border-bottom:1px solid ${borderC};
          transition:background 0.35s,box-shadow 0.35s;
          box-shadow:${shadow};
        }
        .nav::after{content:'';position:absolute;bottom:0;left:0;right:0;height:1px;background:linear-gradient(90deg,transparent,${accent}55,transparent);animation:nscan 4s ease-in-out infinite;}
        @keyframes nscan{0%,100%{transform:scaleX(0);opacity:0;}50%{transform:scaleX(1);opacity:1;}}
        .nav-logo{font-family:'Orbitron',monospace;font-weight:900;font-size:13px;color:${logoC};letter-spacing:2px;text-decoration:none;display:flex;align-items:center;gap:9px;flex-shrink:0;transition:color 0.25s;}
        .nav-logo:hover{color:${accent};}
        .nav-logo-icon{width:28px;height:28px;border-radius:6px;flex-shrink:0;background:${dark?'rgba(0,212,255,0.12)':'rgba(0,120,200,0.1)'};border:1px solid ${dark?'rgba(0,212,255,0.3)':'rgba(0,120,200,0.28)'};display:flex;align-items:center;justify-content:center;}
        .nav-pulse{width:8px;height:8px;border-radius:50%;background:${accent};animation:npulse 2.5s ease-in-out infinite;}
        @keyframes npulse{0%,100%{box-shadow:0 0 6px ${accent};transform:scale(1);}50%{box-shadow:0 0 18px ${accent};transform:scale(1.25);}}
        .nav-links{display:flex;gap:1px;}
        .nl{font-family:'Inter',sans-serif;font-weight:600;font-size:10.5px;letter-spacing:1.5px;text-transform:uppercase;color:${idleC};text-decoration:none;padding:6px 10px;border-radius:4px;border:1px solid transparent;transition:all 0.2s;position:relative;white-space:nowrap;}
        .nl:hover{color:${activeC};border-color:${activeBd};background:${activeBg};}
        .nl.on{color:${activeC};border-color:${activeBd};background:${activeBg};font-weight:700;}
        .nl.on::after{content:'';position:absolute;bottom:-1px;left:20%;right:20%;height:2px;background:${accent};border-radius:2px 2px 0 0;}
        .nav-right{display:flex;align-items:center;gap:8px;flex-shrink:0;}
        .live-badge{display:flex;align-items:center;gap:5px;font-size:10px;font-weight:600;letter-spacing:0.8px;color:${dark?'#00e676':'#007a32'};border:1px solid ${dark?'rgba(0,230,118,0.25)':'rgba(0,122,50,0.22)'};padding:3px 9px;border-radius:20px;background:${dark?'rgba(0,230,118,0.07)':'rgba(0,122,50,0.06)'};}
        .live-dot{width:5px;height:5px;border-radius:50%;background:${dark?'#00e676':'#00aa44'};animation:livepulse 1.8s ease-in-out infinite;}
        @keyframes livepulse{0%,100%{transform:scale(1);}50%{transform:scale(1.5);opacity:0.6;}}
        .tbtn{font-size:11px;font-weight:600;background:${dark?'rgba(0,212,255,0.09)':'rgba(0,120,200,0.08)'};color:${dark?'#c8e8ff':'#0a3060'};border:1px solid ${dark?'rgba(0,212,255,0.28)':'rgba(0,120,200,0.26)'};border-radius:20px;padding:4px 12px;cursor:none;display:flex;align-items:center;gap:4px;transition:all 0.2s;white-space:nowrap;font-family:'Inter',sans-serif;}
        .tbtn:hover{color:${accent};border-color:${accent}88;}
        .ham{display:none;flex-direction:column;gap:5px;background:none;border:none;cursor:none;padding:6px;z-index:1002;}
        .ham-line{width:22px;height:2px;background:${idleC};border-radius:2px;transition:all 0.25s;transform-origin:center;}
        .ham.open .ham-line:nth-child(1){transform:rotate(45deg) translate(5px,5px);background:${accent};}
        .ham.open .ham-line:nth-child(2){opacity:0;transform:scaleX(0);}
        .ham.open .ham-line:nth-child(3){transform:rotate(-45deg) translate(5px,-5px);background:${accent};}
        .mobile-menu{display:none;position:fixed;top:60px;left:0;right:0;bottom:0;background:${mobileBg};backdrop-filter:blur(20px);z-index:999;flex-direction:column;padding:20px 16px;gap:3px;border-top:1px solid ${borderC};overflow-y:auto;animation:slideDown 0.25s ease;}
        @keyframes slideDown{from{opacity:0;transform:translateY(-8px);}to{opacity:1;transform:none;}}
        .mobile-menu.open{display:flex;}
        .mobile-nl{font-family:'Inter',sans-serif;font-weight:600;font-size:13px;letter-spacing:1.5px;text-transform:uppercase;color:${idleC};text-decoration:none;padding:13px 16px;border-radius:6px;border:1px solid transparent;transition:all 0.2s;display:flex;align-items:center;}
        .mobile-nl:hover,.mobile-nl.on{color:${activeC};border-color:${activeBd};background:${activeBg};}
        .mobile-nl.on{font-weight:700;}
        .mob-div{height:1px;background:${borderC};margin:8px 0;}
        @media(max-width:900px){.nav-links{display:none;}.ham{display:flex;}.live-badge{display:none;}}
        @media(max-width:600px){.nav{padding:0 14px;}.nav-logo span{display:none;}}
      `}</style>

      <nav className="nav">
        <Link to="/" className="nav-logo">
          <div className="nav-logo-icon"><div className="nav-pulse" /></div>
          <span>5G·DELAY·AI</span>
        </Link>
        <div className="nav-links">
          {NAV_LINKS.map(([p, l]) => (
            <Link key={p} to={p} className={`nl${loc.pathname === p ? ' on' : ''}`}>{l}</Link>
          ))}
        </div>
        <div className="nav-right">
          <div className="live-badge"><div className="live-dot" />Live</div>
          <button className="tbtn" onClick={toggle}>{dark ? '☀ Light' : '🌙 Dark'}</button>
          <button className={`ham${menuOpen ? ' open' : ''}`} onClick={() => setMenuOpen(o => !o)}>
            <div className="ham-line" /><div className="ham-line" /><div className="ham-line" />
          </button>
        </div>
      </nav>

      <div className={`mobile-menu${menuOpen ? ' open' : ''}`}>
        {NAV_LINKS.map(([p, l]) => (
          <Link key={p} to={p} className={`mobile-nl${loc.pathname === p ? ' on' : ''}`}>{l}</Link>
        ))}
        <div className="mob-div" />
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 4px' }}>
          <span style={{ fontSize: 11, color: dark ? 'rgba(0,212,255,0.6)' : 'rgba(0,100,180,0.6)' }}>{views.toLocaleString()} views</span>
          <button className="tbtn" onClick={toggle}>{dark ? '☀ Light' : '🌙 Dark'}</button>
        </div>
      </div>
    </>
  );
}
